module.exports = __webpack_public_path__ + "static/media/vince_hbo.d7789909.jpeg";